export const CDN = "//gw-static.qianlima.com";

// 邮箱校验
export function emailValid(email) {
  const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  return reg.test(email);
}

// 手机号校验
export function phoneNumValid(phoneNumber) {
  const reg = /^1\d{10}$/;
  return reg.test(phoneNumber);
}

// 倒计时
export function timeCountdown(time, callback) {
  const timer = setInterval(() => {
    time--;
    callback(time);
    if (time === 0) {
      clearInterval(timer);
    }
  }, 1000);

  return {
    stop: function () {
      clearInterval(timer);
    },
  };
}

export function getServicePhone(userInfo) {
  try {
    // isPayBefore 该账号是否付费过，1付过 0没付过，子账号同父账号
    if (userInfo.isPayBefore || userInfo.memberLevel > 5) {
      return "400-900-6616";
    } else {
      return "400-688-2000";
    }
  } catch (e) {
    return "400-688-2000";
  }
}
// 判断是否是空的
export function IsNull(str) {
  return (
    str === undefined ||
    str === "undefined" ||
    str === null ||
    str === "null" ||
    str.length === 0 ||
    JSON.stringify(str) === "{}"
  );
}
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return "-";
  }
  if (time === null) {
    return "-";
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;

  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    if (String(time).indexOf("T") > -1) {
      time = time.replace(/T/g, " ").replace(/\..*/g, "");
    }
    if (String(time).indexOf("-") > -1 && String(time).indexOf("T") === -1) {
      time = (time + "").replace(/-/g, "/");
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return timeStr;
}
